module.exports = require("source-map-support/register");